import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { DeliverablesDashboard } from '@/components/deliverables/DeliverablesDashboard';

export function DeliverablesDashboardPage() {
  return (
    <DashboardLayout title="Deliverables">
      <div className="space-y-1 mb-6">
        <p className="text-sm text-muted-foreground">
          Track deliverables across all projects. See who has the ball and what needs attention.
        </p>
      </div>
      <DeliverablesDashboard />
    </DashboardLayout>
  );
}
